import { PmiButton } from 'shell/components/shared/button';
import { Accordion, AccordionDetails, Grid, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { FormikProps } from 'formik';
import { Fragment, memo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import PmiTextField from 'shell/components/shared/text-field';
import { FiltersFormPlace } from 'civil-status/view-models/place';

interface FiltersPlaceComponentProps {
  filterForm: FormikProps<FiltersFormPlace>;
  labelID?: string;
  labelDescrizione?: string;
  isMinisterReligion?: boolean;
}

const FiltersPlaceComponent = ({
  filterForm,
  labelID = 'Id luogo',
  labelDescrizione = 'Descrizione luogo',
  isMinisterReligion = false,
}: FiltersPlaceComponentProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-birthplace-content"
        id="panel-birthplace-header"
        classes={{
          root: 'pmi-flex-row-reverse',
        }}
        expandIcon={<ExpandMore />}
      >
        <Typography>Filtri</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <form onSubmit={filterForm.handleSubmit}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={4}>
              <PmiTextField
                aria-label={labelID}
                label={labelID}
                id="id"
                name="id"
                fullWidth
                type="text"
                variant="outlined"
                value={filterForm.values.id || ''}
                onChange={(event) => filterForm.setFieldValue('id', event.target.value)}
                error={filterForm.touched.id && Boolean(filterForm.errors.id)}
                helperText={filterForm.errors.id}
              />
            </Grid>
            {!isMinisterReligion ? (
              <Grid item xs={12} md={6}>
                <PmiTextField
                  aria-label={labelDescrizione}
                  label={labelDescrizione}
                  id="description"
                  name="description"
                  fullWidth
                  type="text"
                  variant="outlined"
                  value={filterForm.values.description || ''}
                  onChange={(event) => filterForm.setFieldValue('description', event.target.value)}
                  error={filterForm.touched.description && Boolean(filterForm.errors.description)}
                  helperText={filterForm.errors.description}
                />
              </Grid>
            ) : undefined}
            {isMinisterReligion ? (
              <Fragment>
                <Grid item xs={12} md={4}>
                  <PmiTextField
                    aria-label="Nome"
                    label="Nome"
                    id="name"
                    name="name"
                    fullWidth
                    type="text"
                    variant="outlined"
                    value={filterForm.values.name || ''}
                    onChange={(event) => filterForm.setFieldValue('name', event.target.value)}
                    error={filterForm.touched.name && Boolean(filterForm.errors.name)}
                    helperText={filterForm.errors.name}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <PmiTextField
                    aria-label="Cognome"
                    label="Cognome"
                    id="surname"
                    name="surname"
                    fullWidth
                    type="text"
                    variant="outlined"
                    value={filterForm.values.surname || ''}
                    onChange={(event) => filterForm.setFieldValue('surname', event.target.value)}
                    error={filterForm.touched.surname && Boolean(filterForm.errors.surname)}
                    helperText={filterForm.errors.surname}
                  />
                </Grid>
              </Fragment>
            ) : undefined}
            <Grid item xs={12} md={1}>
              <PmiButton variant="contained" color="secondary" fullWidth type="submit">
                Cerca
              </PmiButton>
            </Grid>
          </Grid>
        </form>
      </AccordionDetails>
    </Accordion>
  );
};

FiltersPlaceComponent.displayName = 'Filters place component';

const FiltersPlace = memo(FiltersPlaceComponent);

export default FiltersPlace;
